module.exports = __webpack_public_path__ + "static/img/heceta.4356d8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/heceta.jpg
// module id = rYtj
// module chunks = 1